/**
 * 文件说明:
 *
 * page main
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, useMemo, useRef} from 'react'
import {Layout, ConfigProvider} from 'antd'
import {usePersistFn} from 'ahooks'
import globalAntConfig from 'common/ant-config'
import classnames from 'classnames'
import {pageMainContext} from './context'
import styles from './index.less'

const PageMain = memo((props) => {
    const {PageHeader, antConfig, className} = props

    const contentRef = useRef()

    const getPageContainer = usePersistFn(() => contentRef.current)

    const configProps = useMemo(
        () => ({
            ...globalAntConfig,
            getPopupContainer: getPageContainer,
            ...antConfig,
        }),
        [antConfig, getPageContainer],
    )

    const pageMainContextValue = useMemo(
        () => ({
            getPageContainer,
        }),
        [getPageContainer],
    )

    return (
        <Layout>
            <ConfigProvider {...configProps}>
                <pageMainContext.Provider value={pageMainContextValue}>
                    <div ref={contentRef} className={classnames(styles.content, className)}>
                        {PageHeader}
                    </div>
                </pageMainContext.Provider>
            </ConfigProvider>
        </Layout>
    )
})

export default PageMain
